import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
export const useVisualViewportHeight = isActive => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== isActive) {
    t0 = () => {
      if (!isActive) {
        return;
      }
      const root = document.documentElement;
      const viewport = globalThis.window?.visualViewport;
      const update = () => {
        const height = viewport?.height ?? globalThis.window.innerHeight;
        root.style.setProperty("--visual-viewport-height", `${height}px`);
      };
      update();
      viewport?.addEventListener("resize", update);
      viewport?.addEventListener("scroll", update);
      return () => {
        viewport?.removeEventListener("resize", update);
        viewport?.removeEventListener("scroll", update);
        root.style.removeProperty("--visual-viewport-height");
      };
    };
    t1 = [isActive];
    $[0] = isActive;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
};